export default {
    payments:{
        type:'Тип статьи'
    }
}
